import React from 'react';
import '../components/styles/Review.css'
import { BaseButton } from '../styles/ButtonStyles';
import styled from 'styled-components';
import placeholder from '../assests/placeholder_image.png';

const ButtonCancel = styled(BaseButton)`
    margin-right:25px;
    background-color:#d7d7d7;
`;

const ReviewView1 = (props) => {
    const isEmptyReview = props.inappProfiles.length === 0 && props.likes.length === 0 && props.passed.length === 0;
    function getSelectedPhotoFromArray(photosArray) {
        for (const photoObj of photosArray) {
            if (photoObj.selected === true) {
                return photoObj.photo;
            }
        }

        if (photosArray.length > 0) {
            return photosArray[0].photo;
        }
        return null;
    }

    return (
        <div className='mainDiv'>
            <div className='divStyles'>
                <div className='profileStateDiv'>
                    <span className='spanStyles'>Inappropriate</span>
                    {
                        props.inappProfiles && props.inappProfiles.length > 0 ?
                            <div className='imageContainer'>
                                {
                                    props.inappProfiles.map((image_name, index) => {
                                        return <div key={index}>
                                            <img className='circleImage' src={props.tabType === 'people' ? getSelectedPhotoFromArray(image_name.photos) : getSelectedPhotoFromArray(image_name.updated_images)} alt='img' onError={(e) => { e.target.src = placeholder }} />
                                            <span>{image_name.first_name}</span>
                                        </div>
                                    })
                                }
                            </div> : null
                    }
                </div>
                <div className='profileStateDiv'>
                    <span className='spanStyles'>Approve</span>
                    {
                        props.likes && props.likes.length > 0 ?
                            <div className='imageContainer'>
                                {
                                    props.likes.map((image_name, index) => {
                                        return <div key={index}>
                                            <img className='circleImage' src={props.tabType === 'people' ? getSelectedPhotoFromArray(image_name.photos) : getSelectedPhotoFromArray(image_name.updated_images)} alt='img' onError={(e) => { e.target.src = placeholder }} />
                                            <span>{image_name.first_name}</span>
                                        </div>
                                    })
                                }
                            </div> : null
                    }
                </div>
                <div className='profileStateDiv'>
                    <span className='spanStyles'>Disapprove</span>
                    {
                        props.passed && props.passed.length > 0 ?
                            <div className='imageContainer'>
                                {
                                    props.passed.map((image_name, index) => {
                                        return <div key={index}>
                                            <img className='circleImage' src={props.tabType === 'people' ? getSelectedPhotoFromArray(image_name.photos) : getSelectedPhotoFromArray(image_name.updated_images)} alt='img' onError={(e) => { e.target.src = placeholder }} />
                                            <span>{image_name.first_name}</span>
                                        </div>
                                    })
                                }
                            </div> : null
                    }
                </div>
            </div>

            <div className='buttonDiv'>
                <ButtonCancel onClick={() => props.cancel()}>Cancel</ButtonCancel>
                <BaseButton onClick={() => props.save()}>Save</BaseButton>
            </div>
        </div>
    )
};

export default ReviewView1;